import { useCallback, useRef } from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { useTracking } from '@change-corgi/core/react/tracking';

import { Waypoint } from 'src/app/shared/components/scroll';

import type { TipCardConfig } from '../types';

export function TipCard({ tip }: { tip: TipCardConfig }) {
	const track = useTracking();
	const viewTracked = useRef(false);
	const trackView = useCallback(() => {
		if (viewTracked.current) return;
		void track('petition_strength_card_view', {
			card: tip.type,
		});
		viewTracked.current = true;
	}, [track, tip.type, viewTracked]);

	return (
		<div className="stroke-weaker flex h-full w-80 flex-col gap-2 rounded-xl border bg-background-base p-5 elevation-low">
			<Text as="p" size="xx-small" variant="heading">
				<Translate value={tip.title} />
			</Text>
			<Text as="p" size="small" variant="body" className="text-typography-weak">
				<Translate value={tip.body} />
			</Text>
			<Link onClick={tip.onClick} size="small" bold data-qa="tip-card-primary-action">
				<Translate value={tip.primaryActionText} />
			</Link>
			<div className="-mt-4">
				<Waypoint horizontal onEnter={trackView} />
			</div>
		</div>
	);
}
